module.exports = __webpack_public_path__ + "c6ccf2506c38f05512045d5047ebd767.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/dirty-fightin-video-poster.jpg
// module id = 257
// module chunks = 0